import { Filter } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/class-control";

interface ButtonFilterProps {
  positionIcon: "start" | "end"
  onClick?: () => void
  classNameIcon?: string
  className?: string
}

export default function ButtonFilter(props: ButtonFilterProps) {

  const icon = () => <Filter className={cn("h-4 w-4", props.classNameIcon)} />

  return (
    <Button
      size="sm"
      variant="outline"
      className={cn("border-gray-600 text-gray-300 hover:bg-gray-700 h-[50px]", props.className)}
      onClick={props.onClick}
    >
      {props.positionIcon === "start" && icon()}
      Filtro
      {props.positionIcon === "end" && icon()}
    </Button>
  )
} 